export default __webpack_public_path__ + "static/jameelMotorsLogoBlue-e0b08d3512ecfb1ae23696b68409eee7.svg";